import React, { Component } from 'react';
import { Card, CardBody, CardImg, CardSubtitle } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export class ImageCard extends Component {
    static initialState() {
        return {
            isShowInfo: false,
        };
    }

    constructor(props) {
        super(props);
        this.state = ImageCard.initialState();
        this.onToggleShowInfo = this.onToggleShowInfo.bind(this);
    }

    onToggleShowInfo() {
        this.setState({
            isShowInfo: !this.state.isShowInfo,
        });
    }

    render() {
        const props = this.props,
            image = props.image,
            coefficient = image.data.height / image.data.width,
            proportions = [
                {
                    width: 120,
                    prefix: '/images/small/',
                },
                {
                    width: 360,
                    prefix: '/images/medium/',
                },
                {
                    width: 620,
                    prefix: '/images/large/',
                },
                {
                    width: 1024,
                    prefix: '/images/big/',
                },
                {
                    width: image.data.width,
                    prefix: '/images/original/',
                },
            ];
        return (
            <div>
                <Card>
                    <FontAwesomeIcon
                        icon="times"
                        onClick={() => props.onDestroy(image)}
                    />
                    <CardImg
                        top
                        width="100%"
                        className="pointer-no-select"
                        src={props.route + 'api/images/small/' + image.name}
                        onClick={this.onToggleShowInfo}
                    />
                    {!this.state.isShowInfo ? null : (
                        <CardBody className="p-2">
                            <CardSubtitle>Ссылки:</CardSubtitle>
                            {proportions.map((proportion, key) =>
                                image.data.width < proportion.width ? null : (
                                    <CardSubtitle key={key} className="mt-1">
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href={`${props.route}api${
                                                proportion.prefix + image.name
                                            }`}
                                        >
                                            {proportion.width}x
                                            {(
                                                proportion.width * coefficient
                                            ).toFixed()}
                                        </a>
                                    </CardSubtitle>
                                )
                            )}
                            {/*<CardText>Some quick example text to build on the card title and make up the bulk of the card's content.</CardText>*/}
                            {/*<Button>Button</Button>*/}
                        </CardBody>
                    )}
                </Card>
            </div>
        );
    }
}
